<script>
import PieChart from '@/components/Chart/Pie.vue';
import AnimatedValue from '@/components/AnimatedValue.vue';

export default {
  components: { AnimatedValue, PieChart },
  props: ['pie', 'count'],

  computed: {
    total() {
      return this.count.reduction + this.count.increase;
    },

    increasePercentage() {
      return this.averageCount(this.count.increase);
    },

    reductionPercentage() {
      return this.averageCount(this.count.reduction);
    },
  },

  methods: {
    averageCount(value) {
      return value && this.total > 0 ? (value / this.total) * 100 : 0;
    },
  },
};
</script>

<template>
  <div class="container">
    <PieChart :radius="pie.radius" :innerRadius="pie.innerRadius" :entries="[{ count: count.reduction }, { count: count.increase }]" strokeWidth="0.5px" />

    <div class="label-box">
      <span>
        <AnimatedValue :value="increasePercentage" />
        <span class="flag">% {{ $t('improvement') }}</span>
      </span>

      <span>
        <AnimatedValue :value="reductionPercentage" />
        <span class="flag">% {{ $t('degradation') }}</span>
      </span>

      <span class="flag">
        <i class="icon-alert" />
        <AnimatedValue :value="count.sensibleCase" /> {{ $t('outliers', count.sensibleCase) }}
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;

  .pie-chart-container {
    margin: 0;
    width: auto;
  }

  .label-box {
    display: flex;
    flex-direction: column;

    .flag {
      font-size: 8px;
    }
  }
}
</style>
